
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $fc76c52dcbc76dc3$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["3EsVB","index.9f451ded.js","hm5VY","icons.c14567a0.svg"]'));

// Importing everything from the model, and making it accesible through the
// model namespace.
// Here, we place the variables that define important aspects of our application.
const $ef19e442e0cefa4b$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $ef19e442e0cefa4b$export$9bec5134f7f38b3a = 10;
const $ef19e442e0cefa4b$export$5feaddb1377b7f5e = 10;
const $ef19e442e0cefa4b$export$7167c830cefcb6b5 = "46cb6435-edbb-4f11-bd6a-3dc96d6a4697";
const $ef19e442e0cefa4b$export$3ce8858248d89a69 = 2.5;



// Function that returns a promise that automatically rejects after a certain amount of time.
const $305e87f8b1fd70ca$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $305e87f8b1fd70ca$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        const fetchPro = uploadData ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        // Fetching the data from the API, considering a timeout.
        const response = await Promise.race([
            fetchPro,
            $305e87f8b1fd70ca$var$timeout((0, $ef19e442e0cefa4b$export$9bec5134f7f38b3a))
        ]);
        const data = await response.json();
        // If the response is not ok, we need to throw an error so that the
        // catch statement is activated.
        if (!response.ok) throw new Error(`${data.message} ${response.status}`);
        return data;
    } catch (err) {
        // Re-throwing the error so that we can handle it on the model.
        throw err;
    }
}; /*
// Transforms the result of a promise into actual JSON readable data.
export const getJSON = async function (url) {
	try {
		// Fetching the data from the API, considering a timeout.
		const response = await Promise.race([fetch(url), timeout(TIMEOUT_SECONDS)]);
		const data = await response.json();

		// If the response is not ok, we need to throw an error so that the
		// catch statement is activated.
		if (!response.ok) throw new Error(`${data.message} ${response.status}`);

		return data;
	} catch (err) {
		// Re-throwing the error so that we can handle it on the model.
		throw err;
	}
};

// Transforms data into JSON objects ready to send to the API.
export const sendJSON = async function (url, uploadData) {
	try {
		// Making a POST request to the API.
		const response = await Promise.race([
			fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(uploadData),
			}),
			timeout(TIMEOUT_SECONDS),
		]);
		const data = await response.json();

		// If the response is not ok, we need to throw an error so that the
		// catch statement is activated.
		if (!response.ok) throw new Error(`${data.message} ${response.status}`);

		return data;
	} catch (err) {
		// Re-throwing the error so that we can handle it on the model.
		throw err;
	}
};
*/ 


const $0f43de04ce3b058c$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        page: 1,
        resultsPerPage: (0, $ef19e442e0cefa4b$export$5feaddb1377b7f5e)
    },
    bookmarks: []
};
const $0f43de04ce3b058c$var$createRecipeObject = function(data) {
    // Since the API returns data with underscore-named variables, we can create
    // a new object and integrate the JS naming conventions there.
    const { recipe: recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f43de04ce3b058c$export$b96725c7a035d60b = async function(id) {
    // Error handling.
    try {
        // Fetching the data from the API.
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}${id}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        // Storing the recipe object on the state
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$createRecipeObject(data);
        // If there's in the actual state a bookmarked recipe, we need to set that property to
        // true on the data obtained from the API.
        if ($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id)) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = true;
        else $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = false;
    } catch (error) {
        console.error(`${error} \u{1F616}`);
        // Throwing the error again so that it can be propagated to the controller.
        throw error;
    }
};
const $0f43de04ce3b058c$export$202b8e5cb363a0c4 = async function(query) {
    try {
        // Storing the query in the state.
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.query = query;
        // Making a request to the API to get the basic info of all recipes
        // that match the query.
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?search=${query}&key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        // console.log(data);
        // Storing the search results on the state object.
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results = data.data.recipes.map((rec)=>{
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                image: rec.image_url,
                ...rec.key && {
                    key: rec.key
                }
            };
        });
        // Whenever we load new results, the page state is reset to 1.
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page = 1;
    } catch (error) {
        console.error(`${error} \u{1F616}`);
        // Throwing the error again so that it can be propagated to the controller.
        throw error;
    }
};
const $0f43de04ce3b058c$export$8d7f79465139ab72 = function(page = $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page) {
    // Saving the current page into the state.
    $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page = page;
    // Dynamically calculating the start and end points.
    const start = (page - 1) * $0f43de04ce3b058c$export$ca000e230c0caa3e.search.resultsPerPage;
    const end = page * $0f43de04ce3b058c$export$ca000e230c0caa3e.search.resultsPerPage;
    // Returning the desired results.
    return $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f43de04ce3b058c$export$5e23f4642ecad5ea = function(newServings) {
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings;
    });
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings = newServings;
};
// Internal function that helps storing the bookmarks on local storage.
const $0f43de04ce3b058c$var$persistBookmakrks = function() {
    localStorage.setItem("bookmarks", JSON.stringify($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks));
};
const $0f43de04ce3b058c$export$72009cc673d27d80 = function(recipe) {
    // Adding a recipe to the state bookmarks array.
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // Marking current recipe bookmarked.
    if (recipe.id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = true;
    // Persisting the bookmarks in the localstorage.
    $0f43de04ce3b058c$var$persistBookmakrks();
};
const $0f43de04ce3b058c$export$136048bcb9946c75 = function(id) {
    // Getting the index of the element that has the target ID.
    const index = $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    // Deleting said element form the bookmarks array.
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    // Marking current recipe as not bookmarked.
    if (id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = false;
    // Persisting the bookmarks in the localstorage.
    $0f43de04ce3b058c$var$persistBookmakrks();
};
// This is only here for development reasons, so that it is easy to clear the bookmarks.
const $0f43de04ce3b058c$var$clearBookmarks = function() {
    localStorage.clear("bookmarks");
};
const $0f43de04ce3b058c$export$d660c2254e74960d = async function(newRecipe) {
    try {
        // Getting the ingredients from the form entries.
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient") && entry[1] !== "").map((ing)=>{
            // Getting the array of ingredients clean.
            const ingArr = ing[1].split(",").map((el)=>el.trim());
            // If there aren't three values (quantity, unit, description), throw an error.
            if (ingArr.length !== 3) throw new Error("Wrong ingredient format! Please use the correct format.");
            // Destructuring the array so that we can have the key-pair values
            const [quantity, unit, description] = ingArr;
            // Returning the obtained values as an object.
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        // Creating the recipe object.
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        console.log(recipe);
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`, recipe);
        // Storing the recipe into the state.
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$createRecipeObject(data);
        // Adding the recipe as a bookmark.
        $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (error) {
        throw error;
    }
};
const $0f43de04ce3b058c$var$init = function() {
    const storage = localStorage.getItem("bookmarks");
    if (storage) $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$0f43de04ce3b058c$var$init();



// Importing parent class.
// Importing the icons.
// These two are the same, but the second one is the one shown in the docs.
// import icons from 'url:../img/icons.svg';
var $eff58e7511e43824$exports = {};
$eff58e7511e43824$exports = new URL("icons.c14567a0.svg", import.meta.url).toString();


const $4c29d8503f9ec531$var$icons = new URL($eff58e7511e43824$exports);
class $4c29d8503f9ec531$export$2e2bcd8739ae039 {
    _data;
    // Method that renders a recipe.
    /**
	 * Render the received object to the DOM.
	 * @param {Object | Object[]} data The data to be render (e.g. a recipe).
	 * @param {boolean} [render=true] If false, create markup string instead of rendering to the DOM.
	 * @returns {undefined | string} A markup string is returned if render=false
	 * @this {Object} View instance
	 * @author Arturo Avila
	 * @todo Finish Implementation
	 */ render(data, render = true) {
        // In case there is no data, or the data is an empty array, render an error.
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        // Generating the markup.
        const markup = this._generateMarkup();
        // If the render parameter is false, we return the markup generated, instead of
        // inserting it on the screen.
        if (!render) return markup;
        this._clear();
        // Inserting the object.
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    // Method that updates certain parts of the view, without updating also the data that stays
    // static.
    update(data) {
        // In case there is no data, or the data is an empty array, render an error.
        // if (!data || (Array.isArray(data) && data.length === 0))
        // 	return this.renderError();
        this._data = data;
        // Generating the markup.
        const newMarkup = this._generateMarkup();
        // Converting the string to a DOM Object, to be then used to make a comparison between itself
        // and what's currently on the page.
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        // Selecting all of the elements on the new virtual DOM, and converting the object into
        // an array.
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        // Selecting all of the elements on the current DOM, and converting the object into
        // an array.
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        // Comparing the elements between the arrays. This is an O(n^2) alg. time-wise from the Big-O
        // perspective.
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // Checking whether or not both nodes have the same content. If the content is different,
            // we update the current DOM accordingly. Also, this only should be done if the content
            // of the node is text, thus avoiding updating entire containers and breaking the UI.
            // This updates changed text.
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") // console.log('😖', newEl.firstChild.nodeValue.trim());
            curEl.textContent = newEl.textContent;
            // This updates changed attributes.
            if (!newEl.isEqualNode(curEl)) // console.log(Array.from(newEl.attributes));
            Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    // Method that clears the HTML from the container.
    _clear() {
        // Cleaning the present markup.
        this._parentElement.innerHTML = "";
    }
    // Spinner used when waiting for data to be loaded.
    renderSpinner() {
        const markup = `
      <div class="spinner">
        <svg>
          <use href="${$4c29d8503f9ec531$var$icons}#icon-loader"></use>
        </svg>
      </div>
    `;
        // Clearing and inserting the spinner as a child of the selected parent element.
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    // Function that renders an error on screen.
    renderError(message = this._errorMessage) {
        const markup = `
      <div class="error">
        <div>
          <svg>
            <use href="${$4c29d8503f9ec531$var$icons}#icon-alert-triangle"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>
    `;
        // Clearing and inserting the error message as a child of the selected parent element.
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    // Function that renders a success message on screen.
    renderMessage(message = this._message) {
        const markup = `
      <div class="message">
        <div>
          <svg>
            <use href="${$4c29d8503f9ec531$var$icons}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>
    `;
        // Clearing and inserting the error message as a child of the selected parent element.
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}


var $47fd1b3d76daecdb$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$47fd1b3d76daecdb$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = "-";
    } else type = "";
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return "0";
    const numberString = number.toString();
    const entry = numberString.split(".");
    let integer = entry[0];
    let decimal;
    if (decimal == "0" && integer !== "0") return integer;
    else if (decimal == "0" && integer == "0") return "0";
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == "99" && integer !== "0") return `${integer} 99/100`;
    else if (decimal == "99" && integer == "0") return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = "999";
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split("").reverse().join(""); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split("").reverse().join("");
        let endPattern = pattern[1].split("").reverse().join("");
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split("");
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $47fd1b3d76daecdb$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $47fd1b3d76daecdb$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $47fd1b3d76daecdb$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $47fd1b3d76daecdb$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $47fd1b3d76daecdb$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $47fd1b3d76daecdb$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == "0") return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}



// Importing the icons.
// These two are the same, but the second one is the one shown in the docs.
// import icons from 'url:../img/icons.svg';
const $96ae62c5a8e43877$var$icons = new URL($eff58e7511e43824$exports);
class $96ae62c5a8e43877$var$RecipeView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".recipe");
    // Defining a default error message.
    _errorMessage = "We could not find that recipe. Please try another one!";
    // Defining a default success message.
    _message = "";
    // This function is part of the publisher-subscriber pattern, and acts as the publisher.
    addHandlerRender(handler) {
        // A better way of implementing multiple triggers for the same function, in the same object.
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    // This function is part of the publisher-subscriber pattern, and acts as the publisher.
    addHandlerUpdateServings(handler) {
        // Event delegation.
        this._parentElement.addEventListener("click", function(e) {
            // Getting the button that was clicked.
            const btn = e.target.closest(".btn--update-servings");
            if (!btn) return;
            // console.log(btn);
            // Determining the servings requested.
            const { updateTo: updateTo } = btn.dataset;
            // Re-rendering the recipe with the new values. This should only be
            // called if the number of servings is greater than 0. Also, the value
            // should be transformed into an integer.
            if (+updateTo > 0) handler(+updateTo);
        });
    }
    // This function is part of the publisher-subscriber pattern, and acts as the publisher.
    addHandlerAddBookmark(handler) {
        // We use event delegation because, by the time the page is loaded, the button that
        // we are interested in does not exist yet. Thus, event delegation proves useful in these
        // cases.
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--bookmark");
            if (!btn) return;
            handler();
        });
    }
    // Method that generates the markup.
    _generateMarkup() {
        // Rendering the recipe.
        return `
    <figure class="recipe__fig">
      <img src="${this._data.image}" alt="${this._data.title}" class="recipe__img" />
      <h1 class="recipe__title">
        <span>${this._data.title}</span>
      </h1>
    </figure>

    <div class="recipe__details">
      <div class="recipe__info">
        <svg class="recipe__info-icon">
          <use href="${$96ae62c5a8e43877$var$icons}#icon-clock"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
        <span class="recipe__info-text">minutes</span>
      </div>
      <div class="recipe__info">
        <svg class="recipe__info-icon">
          <use href="${$96ae62c5a8e43877$var$icons}#icon-users"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
        <span class="recipe__info-text">servings</span>

        <div class="recipe__info-buttons">
          <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings - 1}">
            <svg>
              <use href="${$96ae62c5a8e43877$var$icons}#icon-minus-circle"></use>
            </svg>
          </button>
          <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings + 1}">
            <svg>
              <use href="${$96ae62c5a8e43877$var$icons}#icon-plus-circle"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="recipe__user-generated ${this._data.key ? "" : "hidden"}">
        <svg>
          <use href="${$96ae62c5a8e43877$var$icons}#icon-user"></use>
        </svg>
      </div>
      <button class="btn--round btn--bookmark">
        <svg class="">
          <use href="${$96ae62c5a8e43877$var$icons}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}"></use>
        </svg>
      </button>
    </div>

    <div class="recipe__ingredients">
      <h2 class="heading--2">Recipe ingredients</h2>
      <ul class="recipe__ingredient-list">
      ${this._data.ingredients.map(this._generateMarkupIngredient).join("")}
      </ul>
    </div>

    <div class="recipe__directions">
      <h2 class="heading--2">How to cook it</h2>
      <p class="recipe__directions-text">
        This recipe was carefully designed and tested by
        <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
        directions at their website.
      </p>
      <a
        class="btn--small recipe__btn"
        href="${this._data.sourceUrl}"
        target="_blank"
      >
        <span>Directions</span>
        <svg class="search__icon">
          <use href="${$96ae62c5a8e43877$var$icons}#icon-arrow-right"></use>
        </svg>
      </a>
    </div>
  `;
    }
    // Method that generates the markup for an ingredient.
    _generateMarkupIngredient(ing) {
        return `
      <li class="recipe__ingredient">
        <svg class="recipe__icon">
          <use href="${$96ae62c5a8e43877$var$icons}#icon-check"></use>
        </svg>
        <div class="recipe__quantity">${ing.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($47fd1b3d76daecdb$exports)))(ing.quantity).toString() : ""}</div>
        <div class="recipe__description">
          <span class="recipe__unit">${ing.unit}</span>
          ${ing.description}
        </div>
      </li>
    `;
    }
}
var $96ae62c5a8e43877$export$2e2bcd8739ae039 = new $96ae62c5a8e43877$var$RecipeView();


class $59c24ae67929f662$var$SearchView {
    _parentElement = document.querySelector(".search");
    // Gets the query inserted on the searchbar.
    getQuery() {
        // Returning the query.
        const query = this._parentElement.querySelector(".search__field").value;
        // Clearing the searchbar.
        this._clearInput();
        // Returning the query.
        return query;
    }
    // Method that clears the searchbar.
    _clearInput() {
        this._parentElement.querySelector(".search__field").value = "";
    }
    // This function is part of the publisher-subscriber pattern, and acts as the publisher.
    addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            // Preventing the default behavior of the form.
            e.preventDefault();
            handler();
        });
    }
}
var $59c24ae67929f662$export$2e2bcd8739ae039 = new $59c24ae67929f662$var$SearchView();


// Importing the icons.
// These two are the same, but the second one is the one shown in the docs.
// import icons from 'url:../img/icons.svg';

// Importing the icons.
// These two are the same, but the second one is the one shown in the docs.
// import icons from 'url:../img/icons.svg';


const $8b7f4ee14226945a$var$icons = new URL($eff58e7511e43824$exports);
class $8b7f4ee14226945a$var$PreviewView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = "";
    _generateMarkup() {
        // Determining the id of the current page.
        const id = window.location.hash.slice(1);
        return `
      <li class="preview">
        <a class="preview__link ${this._data.id === id ? "preview__link--active" : ""}" href="#${this._data.id}">
          <figure class="preview__fig">
            <img src="${this._data.image}" alt="${this._data.title}" />
          </figure>
          <div class="preview__data">
            <h4 class="preview__title">${this._data.title}</h4>
            <p class="preview__publisher">${this._data.publisher}</p>
            <div class="preview__user-generated ${this._data.key ? "" : "hidden"}">
              <svg>
                <use href="${$8b7f4ee14226945a$var$icons}#icon-user"></use>
              </svg>
            </div>
          </div>
        </a>
      </li>
    `;
    }
}
var $8b7f4ee14226945a$export$2e2bcd8739ae039 = new $8b7f4ee14226945a$var$PreviewView();



const $9b828d38d31fb13a$var$icons = new URL($eff58e7511e43824$exports);
class $9b828d38d31fb13a$var$ResultsView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "No recipies found for your query! Please try again.";
    // Defining a default success message.
    _message = "";
    _generateMarkup() {
        return this._data.map((result)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(result, false)).join("");
    }
}
var $9b828d38d31fb13a$export$2e2bcd8739ae039 = new $9b828d38d31fb13a$var$ResultsView();


// Importing the icons.
// These two are the same, but the second one is the one shown in the docs.
// import icons from 'url:../img/icons.svg';


const $d5cb92833965f6d1$var$icons = new URL($eff58e7511e43824$exports);
class $d5cb92833965f6d1$var$PaginationView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    addHandlerClick(handler) {
        // Using event delegation.
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--inline");
            if (!btn) return;
            // Getting the target page.
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    _generateMarkupButtonNext(page) {
        return `
			<button data-goto=${page + 1} class="btn--inline pagination__btn--next">
				<span>Page ${page + 1}</span>
				<svg class="search__icon">
					<use href="${$d5cb92833965f6d1$var$icons}#icon-arrow-right"></use>
				</svg>
			</button>
		`;
    }
    _generateMarkupButtonPrev(page) {
        return `
				<button data-goto=${page - 1} class="btn--inline pagination__btn--prev">
					<svg class="search__icon">
						<use href="${$d5cb92833965f6d1$var$icons}#icon-arrow-left"></use>
					</svg>
					<span>Page ${page - 1}</span>
				</button>
			`;
    }
    _generateMarkup() {
        // Getting the total number of pages.
        const curPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        // console.log(numPages);
        // Page 1, and there are other pages.
        if (curPage === 1 && numPages > 1) return this._generateMarkupButtonNext(curPage);
        // Last page.
        if (curPage === numPages && numPages > 1) return this._generateMarkupButtonPrev(curPage);
        // Other page.
        if (curPage < numPages) return this._generateMarkupButtonPrev(curPage) + this._generateMarkupButtonNext(curPage);
        // Page 1, and there are no other pages.
        return "";
    }
}
var $d5cb92833965f6d1$export$2e2bcd8739ae039 = new $d5cb92833965f6d1$var$PaginationView();


// Importing the icons.
// These two are the same, but the second one is the one shown in the docs.
// import icons from 'url:../img/icons.svg';



const $bb8c26dfe22e3ec0$var$icons = new URL($eff58e7511e43824$exports);
class $bb8c26dfe22e3ec0$var$BookmarksView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bookmarks__list");
    _errorMessage = "No bookmarks yet. Find a nive recipe and bookmark it c:";
    // Defining a default success message.
    _message = "";
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data.map((bookmark)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(bookmark, false)).join("");
    }
}
var $bb8c26dfe22e3ec0$export$2e2bcd8739ae039 = new $bb8c26dfe22e3ec0$var$BookmarksView();


// Importing the icons.
// These two are the same, but the second one is the one shown in the docs.
// import icons from 'url:../img/icons.svg';


const $69f230dbd0cf4929$var$icons = new URL($eff58e7511e43824$exports);
class $69f230dbd0cf4929$var$AddRecipeView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".upload");
    _message = "Recipe was successfully uploaded c:";
    _window = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _btnOpen = document.querySelector(".nav__btn--add-recipe");
    _btnClose = document.querySelector(".btn--close-modal");
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    toggleWindow() {
        // Removing the hidden class on the overlay and the window.
        this._overlay.classList.toggle("hidden");
        this._window.classList.toggle("hidden");
    }
    _addHandlerShowWindow() {
        this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    }
    _addHandlerHideWindow() {
        this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
        this._overlay.addEventListener("click", this.toggleWindow.bind(this));
    }
    addHandlerUpload(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            // Preventing default behavior.
            e.preventDefault();
            // Using the Form Data API to get the data on the form.
            const dataArr = [
                ...new FormData(this)
            ];
            // Transforming the entries into an object.
            const data = Object.fromEntries(dataArr);
            handler(data);
        });
    }
    _generateMarkup() {}
}
var $69f230dbd0cf4929$export$2e2bcd8739ae039 = new $69f230dbd0cf4929$var$AddRecipeView();


// Importing the modules required for polyfilling.
// Polyfilling everything else.
// import 'core-js/stable';
// // Polyfilling async/await.
// import 'regenerator-runtime/runtime.js';
///////////////////////////////////////
// Test request for getting a recipe.
const $292b382f80842f30$var$controlRecipes = async function() {
    try {
        // Getting the id of the recipe from the hash on the URL.
        const id = window.location.hash.slice(1);
        // If there is no id on the URL (e.g. we have not selected any recipe), then
        // no recipe should me shown and this function must be exited.
        if (!id) return;
        // Showing the spinner.
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderSpinner();
        // Updating the results view to mark the selected one.
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$8d7f79465139ab72());
        // Updating the bookmarks view to mark the selected one.
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        // Loading the recipe.
        await $0f43de04ce3b058c$export$b96725c7a035d60b(id);
        // Rendering the recipe
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        // Showing the error message on screen.
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderError();
        console.error(err);
    }
};
const $292b382f80842f30$var$controlSearchResults = async function() {
    try {
        // Getting the query present on the search bar.
        const query = (0, $59c24ae67929f662$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        // Rendering a spinner on the results section.
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).renderSpinner();
        // Loading the results.
        await $0f43de04ce3b058c$export$202b8e5cb363a0c4(query);
        // Rendering the results.
        // resultsView.render(model.state.search.results);
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$8d7f79465139ab72());
        // Render the initial pagination buttons.
        (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
    } catch (err) {
        console.log(err);
    }
};
const $292b382f80842f30$var$controlPagination = function(goToPage) {
    // Going to the selected page.
    (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$8d7f79465139ab72(goToPage));
    // Rendering the buttons.
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
};
const $292b382f80842f30$var$controlServings = function(newServings) {
    // Updating the recipie servings in state.
    $0f43de04ce3b058c$export$5e23f4642ecad5ea(newServings);
    // Updating the recipe view.
    // recipeView.render(model.state.recipe);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
};
const $292b382f80842f30$var$controlAddBookmark = function() {
    // If the recipe is not bookmarked, we bookmark it. Else, we un-bookmark it.
    if (!$0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked) $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    else $0f43de04ce3b058c$export$136048bcb9946c75($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id);
    // Updating the recipe view.
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    // Rendering the bookmarks.
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
const $292b382f80842f30$var$controlBookmarks = function() {
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
const $292b382f80842f30$var$controlAddRecipe = async function(newRecipe) {
    try {
        // Show loading spinner.
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderSpinner();
        // Uploading the data for the new recipe.
        await $0f43de04ce3b058c$export$d660c2254e74960d(newRecipe);
        console.log($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
        // Rendering the new recipe.
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
        // Displaying a success message.
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderMessage();
        // Re-render the bookmark view.
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        // Change ID in the URL without reloading the page.
        window.history.pushState(null, "", `#${$0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id}`);
        // Closing the form window after a certain time.
        setTimeout(function() {
            (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).toggleWindow();
        }, (0, $ef19e442e0cefa4b$export$3ce8858248d89a69) * 1000);
    // ADDME: Regenerating the markup of the upload form.
    } catch (error) {
        console.error("\uD83D\uDE16", error);
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderError(error.message);
    }
};
// This function is part of the publisher-subscriber pattern, and acts as the subscriber.
const $292b382f80842f30$var$init = function() {
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$controlBookmarks);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$controlRecipes);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerUpdateServings($292b382f80842f30$var$controlServings);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerAddBookmark($292b382f80842f30$var$controlAddBookmark);
    (0, $59c24ae67929f662$export$2e2bcd8739ae039).addHandlerSearch($292b382f80842f30$var$controlSearchResults);
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).addHandlerClick($292b382f80842f30$var$controlPagination);
    (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).addHandlerUpload($292b382f80842f30$var$controlAddRecipe);
};
$292b382f80842f30$var$init();


//# sourceMappingURL=index.9f451ded.js.map
